import React from 'react';
import { FdrImage } from '@hotelplan/fdr.regular.basis.fdr-image';
import { FdrImageTextFragment } from 'schemas/fragment/regular/fdrText.generated';
import {
  FdrImageTextComponentContainer,
  FdrImageTextComponentWrapper,
  FdrTextWrapper,
} from './fdr-image-text-component.styles';

interface IFdrImageTextComponentProps {
  data: FdrImageTextFragment;
}

const FdrImageTextComponent = ({ data }: IFdrImageTextComponentProps) => {
  const {
    text,
    image,
    placement,
    title,
    bgColor,
    fgColor,
    width,
    topPadding,
    bottomPadding,
  } = data;

  const blockBottomPadding =
    bottomPadding === 'NONE'
      ? 'none-padding-bottom'
      : bottomPadding === 'SMALL'
      ? 'small-padding-bottom'
      : '';

  const blockTopPadding =
    topPadding === 'NONE'
      ? 'none-padding-top'
      : topPadding === 'SMALL'
      ? 'small-padding-top'
      : '';

  return (
    <FdrImageTextComponentWrapper
      bgColor={bgColor}
      data-id="image-text-component"
    >
      <FdrImageTextComponentContainer
        imagePlacement={placement}
        fontColor={fgColor}
        componentWidth={width}
        className={`${blockBottomPadding} ${blockTopPadding}`}
      >
        {image ? (
          <FdrImage
            image={{
              ...image,
              resized:
                width === 'LARGE'
                  ? image.imageTextResizedLarge
                  : image.imageTextResized,
            }}
            className="image"
          />
        ) : null}
        <FdrTextWrapper>
          <h2 className="title">{title}</h2>
          <div className="text" dangerouslySetInnerHTML={{ __html: text }} />
        </FdrTextWrapper>
      </FdrImageTextComponentContainer>
    </FdrImageTextComponentWrapper>
  );
};

export default FdrImageTextComponent;
